
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import OrderService from '@/services/order.service';
// import moment from 'moment';

@Component({
  filters: {
    payTimeFormat(time: string) {
      return time.startsWith('0000') ? null : time;
    },
  },
})
export default class OrderDrawer extends Vue {
  @lazyInject(OrderService)
  orderService!: OrderService;

  visible = false;

  listData: any = {};

  async init(val: any) {
    const param: any = {
      orderId: val,
    };
    const data = await this.orderService.getList(param);
    if (data) {
      this.listData = data?.list;
      this.visible = true;
    }
  }

  onClose() {
    this.visible = false;
  }
}
